import { render, staticRenderFns } from "./PublicationElement.vue?vue&type=template&id=5dfff939&scoped=true&"
import script from "./PublicationElement.vue?vue&type=script&lang=js&"
export * from "./PublicationElement.vue?vue&type=script&lang=js&"
import style0 from "./PublicationElement.vue?vue&type=style&index=0&id=5dfff939&scoped=true&lang=scss&"
import style1 from "./PublicationElement.vue?vue&type=style&index=1&id=5dfff939&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dfff939",
  null
  
)

export default component.exports